const contractText = (value) =>
  String(
    value && typeof value === "object"
      ? value.value || value.label || value.name || ""
      : value || "",
  ).trim();

export const getAdditionalActContractType = (contract) =>
  contractText(contract).match(/\bLP00[1-6]\b/i)?.[0].toUpperCase() || "";

export const isConsignmentAdditionalAct = (contract) =>
  ["LP001", "LP002"].includes(getAdditionalActContractType(contract));

export const getAdditionalActWorkflow = (contract) =>
  isConsignmentAdditionalAct(contract)
    ? {
        provider: "zoho",
        path: "/api/contracte/zoho/act-aditional-consignatie",
      }
    : getAdditionalActContractType(contract)
      ? {
          provider: "zoho",
          path: "/api/contracte/zoho/act-aditional-vanzare-directa",
        }
      : {
          provider: "signnow",
          path: "/api/contracts/signnow/workflow-act-aditional",
        };

export const isAdditionalActSubmitted = (response, provider) =>
  response.status >= 200 &&
  response.status < 300 &&
  (provider !== "zoho" ||
    (response.data?.ok === true && response.data?.submitted === true));

export const getAdditionalActFailureFeedback = (data) => ({
  severity: data?.invitation_sent === true ? "warning" : "error",
  preventRetry:
    data?.invitation_sent === true ||
    data?.code === "SIGNNOW_SUBSCRIPTION_EXPIRED",
  message:
    data?.message ||
    data?.error ||
    "A apărut o eroare la crearea actului adițional.",
});
